import {
	MessageGroup,
	PersonPublicNameFormat,
	useCanViewerSendMessageInGroupQuery,
	useMessageGroupCountQuery,
} from "../../../Utilities";
import { viewerMessageGroupFilter } from "./filters";

export function useIsViewerInMessageGroup(messageGroupID: MessageGroup["id"]) {
	const { loading, data } = useMessageGroupCountQuery({
		variables: {
			filters: {
				and: [{ idEQ: messageGroupID }, viewerMessageGroupFilter],
			},
		},
	});
	const isViewerInMessageGroup = !!data && data.messageGroupConnection.totalCount > 0;

	return {
		loading,
		isViewerInMessageGroup,
	};
}

export function useCanViewerSendMessageInGroup(messageGroupID: MessageGroup["id"]) {
	const { loading, data } = useCanViewerSendMessageInGroupQuery({ variables: { messageGroupID } });
	const isViewerInMessageGroup =
		!!data && (data.messageGroup.userGroups.some((ug) => ug.members.length > 0) || data.messageGroup.users.length > 0);
	const isGroupMessage = !!data && data.messageGroup.userGroups.length > 0;
	const isNameHidden = !!data && data.viewer.person?.publicNameFormat === PersonPublicNameFormat.Hidden;

	return {
		loading,
		canSendMessage: isViewerInMessageGroup && !(isGroupMessage && isNameHidden),
	};
}
